/**
 * FloatingDoodles — subtle animated owls (flying) and elephants (walking) drifting
 * across the whole app in a fixed, non-interactive background layer.
 */
export default function FloatingDoodles() {
  const items = [
    { kind: "owl",      top: "12%", dur: 42, delay: 0,  scale: 1,    dir: "ltr" },
    { kind: "elephant", top: "82%", dur: 58, delay: 4,  scale: 1.1,  dir: "rtl" },
    { kind: "owl",      top: "38%", dur: 55, delay: 9,  scale: 0.85, dir: "rtl" },
    { kind: "elephant", top: "65%", dur: 65, delay: 18, scale: 0.9,  dir: "ltr" },
    { kind: "owl",      top: "72%", dur: 50, delay: 22, scale: 0.7,  dir: "ltr" },
    { kind: "elephant", top: "22%", dur: 70, delay: 30, scale: 0.75, dir: "rtl" },
  ];

  return (
    <div className="floating-doodles" aria-hidden="true" data-testid="floating-doodles">
      {items.map((it, i) => (
        <div
          key={i}
          className={`doodle doodle-${it.dir}`}
          style={{
            top: it.top,
            animationDuration: `${it.dur}s`,
            animationDelay: `${it.delay}s`,
            transform: `scale(${it.scale})`,
          }}
        >
          {it.kind === "owl" ? <Owl /> : <Elephant />}
        </div>
      ))}
    </div>
  );
}

function Owl() {
  return (
    <svg viewBox="0 0 64 64" width="56" height="56" className="doodle-owl">
      <g fill="none" stroke="#5C061C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        {/* body */}
        <ellipse cx="32" cy="34" rx="16" ry="20" fill="#FDE8D2" />
        {/* head tufts */}
        <path d="M20 14 L24 22 M44 14 L40 22" />
        {/* eyes */}
        <circle cx="26" cy="28" r="5" fill="#FFFFFF" />
        <circle cx="38" cy="28" r="5" fill="#FFFFFF" />
        <circle cx="26" cy="28" r="2" fill="#5C061C" />
        <circle cx="38" cy="28" r="2" fill="#5C061C" />
        {/* beak */}
        <path d="M32 32 L30 36 L34 36 Z" fill="#D97706" stroke="#B45309" />
        {/* wings */}
        <path d="M16 34 Q10 42 18 50" />
        <path d="M48 34 Q54 42 46 50" />
        {/* belly lines */}
        <path d="M26 40 Q32 44 38 40" />
        {/* feet */}
        <path d="M28 52 L28 56 M32 52 L32 56 M36 52 L36 56" />
      </g>
    </svg>
  );
}

function Elephant() {
  return (
    <svg viewBox="0 0 96 64" width="80" height="56" className="doodle-elephant">
      <g fill="none" stroke="#5C061C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        {/* body */}
        <path d="M14 40 Q14 22 34 22 L64 22 Q80 22 82 36 L82 48 L14 48 Z" fill="#F5C6A5" />
        {/* head */}
        <circle cx="30" cy="30" r="14" fill="#F5C6A5" />
        {/* eye */}
        <circle cx="28" cy="27" r="1.5" fill="#5C061C" />
        {/* ear */}
        <path d="M28 18 Q18 16 20 30 Q26 32 30 26 Z" fill="#EBB088" />
        {/* trunk */}
        <path d="M20 34 Q10 40 16 50 Q24 54 26 46" fill="#F5C6A5" />
        {/* tusk */}
        <path d="M22 38 L18 42" stroke="#FFF7E6" strokeWidth="2" />
        {/* legs */}
        <path d="M26 48 L26 60 M42 48 L42 60 M62 48 L62 60 M78 48 L78 60" />
        {/* toenails */}
        <path d="M24 60 L28 60 M40 60 L44 60 M60 60 L64 60 M76 60 L80 60" />
        {/* tail */}
        <path d="M82 42 Q90 42 88 50" />
      </g>
    </svg>
  );
}
